import $ from 'jquery';

import Swiper, {
  Autoplay as SwiperAutoplay,
  Controller as SwiperController,
  EffectFade as SwiperEffectFade,
  Navigation as SwiperNavigation,
  Pagination as SwiperPagination,
} from 'swiper';

Swiper.use([SwiperAutoplay, SwiperController, SwiperEffectFade, SwiperNavigation, SwiperPagination]);

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'block-swiper';
const slidableBreakpoint = '1200px';
let autoplayTime = 2000;

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class SectorsSlider {
  constructor(el) {
    this._sliderActivated = false;

    this.el = el;
    this.swiper = null;

    this.$swiperContainer = $(el).find('.swiper');
    this.$swiperPrev = $(el).find('.swiper-button-prev');
    this.$swiperNext = $(el).find('.swiper-button-next');
    this.$swiperPagination = $(el).find('.swiper-pagination');
    this.$tabs = $(el).find(`.swiper-slide`);
    this.$swiperLoop = $(el).find('.swiper').attr('data-slider-loop');
    this.$swiperEffect = $(el).find('.swiper').attr('data-slider-effect');
    this.$swiperAutoplay = $(el).find('.swiper').attr('data-slider-autoplay');

    this.mediaMatcher = window.matchMedia(`(min-width: ${slidableBreakpoint})`);

    this.hasLoop = true;

    let isCategorySlide = false;

    if (this.mediaMatcher.matches) {
      if (this.$swiperContainer.hasClass('category-boxes') && this.$tabs.length == 2) {
        this.destroySlider();
        return;
      } else if (this.$swiperContainer.hasClass('category-boxes')) {
        isCategorySlide = true;
      }

      this.initSlider(this.$swiperEffect, this.$swiperLoop, false, isCategorySlide);

      if (this.$swiperContainer) {
        var t = 0; // the height of the highest element (after the function runs)
        var t_elem;  // the highest element (after the function runs)
        this.$swiperContainer.find('.swiper-slide .swiper-slide__content').each(function () {
          let $this = $(this);
          if ($this.outerHeight() > t) {
            t_elem = this;
            t = $this.outerHeight();
          }
        });

        $(el).find('.swiper-interaction').css('top', t + 'px');
      }

    } else {
      if (this.$swiperContainer.hasClass('category-boxes') && this.$tabs.length <= 1) {
        this.destroySlider();

        return;
      } else if (this.$swiperContainer.hasClass('category-boxes')) {
        isCategorySlide = true;
      }

      this.initSlider('slide', this.$swiperLoop, true, isCategorySlide);
    }

    $(window).resize(function() {
      if (this.$swiperContainer) {
        // const height = this.$swiperContainer.find('.swiper-slide-active .swiper-slide__content').outerHeight(true);

        var t=0; // the height of the highest element (after the function runs)
        var t_elem;  // the highest element (after the function runs)
        this.$swiperContainer.find('.swiper-slide .swiper-slide__content').each(function () {
          let $this = $(this);
          if ( $this.outerHeight() > t ) {
            t_elem=this;
            t=$this.outerHeight();
          }
        });

        $(el).find('.swiper-interaction').css('top', t + 'px');

      }
    });

    if (this.$swiperAutoplay  > autoplayTime) {
      autoplayTime = this.$swiperAutoplay;
    }

    this.mediaMatcher.addEventListener('change', (event) => {
      if (event.matches) {
        this.destroySlider();
        this.initSlider(this.$swiperEffect, this.$swiperLoop, false);

        var t=0; // the height of the highest element (after the function runs)
        var t_elem;  // the highest element (after the function runs)
        this.$swiperContainer.find('.swiper-slide .swiper-slide__content').each(function () {
          let $this = $(this);
          if ( $this.outerHeight() > t ) {
            t_elem=this;
            t=$this.outerHeight();
          }
        });

        $(el).find('.swiper-interaction').css('top', t + 'px');

      } else {
        this.destroySlider();
        this.initSlider('slide', false, true);
      }
    });
  }

  initSlider(setEffect, isLoop, moreThan2, isCategorySlide) {
    if (this._sliderActivated || this.$tabs.length < 1 && moreThan2 == false && !this.el.classList.contains('block-swiper--variant-1') && isCategorySlide == false || this.$tabs.length == 1) {
      return;
    }

    this.swiper = new Swiper(this.$swiperContainer[0], {
      slidesPerView: "auto",
      centeredSlides: false,
      loop: isLoop,
      loopedSlides: 3,

      pagination: {
        el: this.$swiperPagination[0],
        type: "bullets",
        clickable: true,
      },

      autoplay: {
        disableOnInteraction: false,
        delay: autoplayTime,
      },

      keyboard: {
        enabled: true,
      },

      navigation: {
        nextEl: this.$swiperNext[0],
        prevEl: this.$swiperPrev[0],
      },

      effect: setEffect,
      observer: true,
      observeParents: true,
      observeSlideChildren: true
    });

    this._sliderActivated = true;

    if (!this.$swiperAutoplay) {
      this.swiper.autoplay.stop();
    }
  }

  destroySlider() {
    if (this._sliderActivated === false || this.$tabs.length < 1) {
      return;
    }

    this.swiper.destroy();
    this.swiper = null;

    this._sliderActivated = false;
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new SectorsSlider(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
